import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { msHelpUrlServer } from 'src/app/global_constants';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  createTicketSubject : Subject<any>;
  requestListSubject : Subject<any>;
  requestDetailSubject : Subject<any>;
  lastRequestsSubject : Subject<any>;
  historySubject : Subject<any>;
  baseUrl = msHelpUrlServer.concat("/help/v1/support/request");
  token:any;
  constructor(
    private httpClient: HttpClient
  ) { 
    this.createTicketSubject = new Subject();
    this.requestListSubject = new Subject();
    this.requestDetailSubject = new Subject();
    this.lastRequestsSubject = new Subject();
    this.historySubject = new Subject();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
  }

  createTicket(reqBody : any) : Observable<any> {
    this.createTicketSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    return this.httpClient.post(this.baseUrl, reqBody, {headers: header})
  }

  getRequestList() {
    this.requestListSubject = new Subject();
    let headers: HttpHeaders = new HttpHeaders().set('Authorization', "Bearer " + this.token);
    this.httpClient.get(this.baseUrl, { headers: headers }).subscribe(
      (response: any) => {
        this.requestListSubject.next(response);
        this.requestListSubject.complete();
      },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getHistory(ticketId : any) {
    this.historySubject = new Subject();
    let headers: HttpHeaders = new HttpHeaders().set('Authorization', "Bearer " + this.token);
    this.httpClient.get(this.baseUrl+'/history/'+ticketId, { headers: headers }).subscribe(
      (response: any) => {
        this.historySubject.next(response);
        this.historySubject.complete();
      },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getLastRequests(limit: number = 5) {
    this.lastRequestsSubject = new Subject();
    let headers: HttpHeaders = new HttpHeaders().set('Authorization', "Bearer " + this.token);
    this.httpClient.get(`${this.baseUrl}/last`, { headers: headers, params: { limit: limit.toString() } }).subscribe(
      (response: any) => {
        this.lastRequestsSubject.next(response);
        this.lastRequestsSubject.complete();
      },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getTicketsByStatus(status: number): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders().set('Authorization', "Bearer " + this.token);
    return this.httpClient.get(`${this.baseUrl}/status/${status}`, { headers });
  }

  // getRequestDetail(requestId: string) {
  //   this.requestDetailSubject = new Subject();
  //   let headers: HttpHeaders = new HttpHeaders().set('Authorization', "Bearer " + this.token);
  //   const url = `${this.baseUrl}/${requestId}`;
  //   this.httpClient.get(url, { headers: headers }).subscribe(
  //     (response: any) => {
  //       this.requestDetailSubject.next(response);
  //       this.requestDetailSubject.complete();
  //     },
  //     error => {
  //       console.error('There was an error!', error);
  //     }
  //   );
  // }
  getRequestDetail(requestId: string): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders().set('Authorization', "Bearer " + this.token);
    const url = `${this.baseUrl}/${requestId}`;
    return this.httpClient.get(url, { headers: headers });
  }

  updateTicket(updateTicketRequest: any): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders().set('Authorization', "Bearer " + this.token);
    return this.httpClient.patch(this.baseUrl, updateTicketRequest, { headers: headers });
  }
}
